export default function Brand() {
  return (
    <a className="brand" href="/" aria-label="VolleyWire home">
      <span className="brand-mark" aria-hidden="true">
        <span className="brand-mark-line" />
        <span className="brand-mark-ball" />
      </span>
      <span>
        <strong>VolleyWire</strong>
        <small>The Home of College Volleyball</small>
      </span>
    </a>
  );
}
